export const colors = {
  gray: {
    100: "#F2F4F7",
    200: "#E8ECF2",
    300: "#D8DCE5",
    400: "#B6BCC8",
    500: "#9FA7B2",
    600: "#848C98",
    700: "#757C86",
    800: "#5E646D",
    900: "#40444A",
  },
  white: "#FFFFFF",
  black: "#1C1D1F",
  blue: {
    100: "#F7FAFF",
    200: "#F0F5FF",
    300: "#E8F0FF",
    400: "#DBE7FF",
    500: "#99BBFD",
    600: "#4C89FF",
    700: "#053692",
    800: "#1D68F9",
  },
  lightblue: "rgba(76, 212, 234, 0.89)",
  orange: "#FF8C3C",
  red: "#F72A5C",
  purple: "#8479FF",
  primary: "#053692",
};
